import React from 'react';
import { useI18n } from '../../../../data/hooks/i18nHooks';
import ButtonLink from '../../ButtonLink';
import styles from './MeetingRejectButton.module.scss';
import { isMeetingCancellable } from '../../../../data/filters/meetingFilters';
import { isMeetingCancelled, isMeetingConfirmed } from 'common-data-handling';
import { isMeetingCreatedByUser } from '../../../../data/filters/meetings/isMeetingCreatedByUser';
import { useMyUserId } from '../../../../data/hooks/sessionHooks';

function MeetingRejectButton(props) {
    const { className = '', meeting } = props,
        i18n = useI18n(),
        selfUserId = useMyUserId(),
        meetingCreator = isMeetingCreatedByUser(selfUserId, meeting),
        label = meetingCreator ? i18n['label.cancel'] : i18n['label.reject'];

    if (!isMeetingCancellable(meeting)) return null;

    return (
        <ButtonLink className={[className, styles.MeetingRejectButton].join(' ')} href="./reject">
            {label}
        </ButtonLink>
    );
}

export default MeetingRejectButton;
